/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReportDto } from '../../models/report-dto';

export interface GetCommercialReport$Params {
  customerGUID: string;
}

export function getCommercialReport(http: HttpClient, rootUrl: string, params: GetCommercialReport$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportDto>> {
  const rb = new RequestBuilder(rootUrl, getCommercialReport.PATH, 'get');
  if (params) {
    rb.query('customerGUID', params.customerGUID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReportDto>;
    })
  );
}

getCommercialReport.PATH = '/crefo/report/commercial';
